export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de reportes"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones de calidad"])},
          "filter_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtrar"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar"])},
          "all_producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todos los productores"])},
          "all_organizations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todas las organizaciones"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to list of reports"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality inspections"])},
          "filter_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download"])},
          "all_producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All producers"])},
          "all_organizations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All organizations"])}
        }
      }
    }
  })
}